/*
  Printed Nonsense: product page helper (about 20 lines, no libraries).
  When a shopper picks a colour or size while the photo gallery has scrolled out of view
  (tablet, or phone with the sticky photo switched off), bring the gallery back into view
  so they can see the new colour straight away. Does nothing when the gallery is already visible.
*/
(function () {
  var timer;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.closest || !target.closest('variant-picker')) return;

      clearTimeout(timer);
      timer = setTimeout(function () {
        var media = document.querySelector('.product-information__media');
        if (!media) return;

        var header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
        var rect = media.getBoundingClientRect();

        // gallery fully above the visible area: scroll back up to it
        if (rect.bottom < header + 40) {
          window.scrollTo({
            top: window.scrollY + rect.top - header - 8,
            behavior: reduce ? 'auto' : 'smooth',
          });
        }
      }, 250);
    },
    true
  );
})();